<template>
  <div id="PageNotFound" class="fixedheight">

    <main>
      <div id="image">
        <img src="../assets/img/404.svg">
      </div>
      <div id="text">
        <h1>Houston, we've had a problem here.</h1>
        <p>It seems like the page you are looking for does not exist.</p>
        <router-link :to="{name:'home'}"><button class="btnPrimary">Take me home</button></router-link>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Topnav from './General/Topnav'
import Footer from './General/Footer'

export default {
  name: 'PageNotFound',
  components: {
    Topnav,
    Footer
  }
}
</script>

<style>
  @import '../assets/style/general.css';

  /*tablet and laptop*/
  @media only screen
  and (max-device-width: 1199px) {
    #PageNotFound main{
      flex-direction: column;
    }
    #PageNotFound main #image{
      margin:0px !important;
      margin-bottom:40px !important;
      width:80% !important;
    }
    #PageNotFound main #text *{
      text-align: center;
    }
    #PageNotFound main #text a{
      display: block;
    }
  }

  /*phone*/
  @media only screen
  and (max-device-width: 600px) {
    #PageNotFound main{
      width:90% !important;
      margin-top:0 !important;
      margin-bottom:0 !important;
      padding-bottom: 40px;
    }
    #PageNotFound main #image{
      width:100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/PageNotFound.vue